import request from '@/utils/request'

function list (params) {
  return request({
    url: `/category?max=${params.max}&offset=${params.offset}`,
    method: 'get',
    data: params
  })
}
function add (params) {
  return request({
    url: `/category`,
    method: 'post',
    data: params
  })
}
function update (params) {
  return request({
    url: `/category/${params.id}`,
    method: 'put',
    data: params
  })
}
function remove (category_id) {
  return request({
    url: `/category/${category_id}`,
    method: 'delete'
  })
}
function validateName (params) {
  return request({
    url: `/category/validate/name`,
    method: 'post',
    data: params
  })
}
function ancestors (category_id) {
  return request({
    url: `category/${category_id}/ancestors`,
    method: 'get',
  })
}
export default {
    list,
    add,
    update,
    remove,
    validateName,
    ancestors
}
